import classnames from 'classnames';

import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { FcWithFlag } from '@hh.ru/magritte-types';
import { RadioSkeleton } from '@hh.ru/magritte-ui-checkbox-radio/RadioSkeleton';
import { RadioProps } from '@hh.ru/magritte-ui-checkbox-radio/types';
import { RadioCircleSize24 } from '@hh.ru/magritte-ui-icon/variants/private';
import { enrichWithSkeleton } from '@hh.ru/magritte-ui-skeleton';

import styles from './radio.less';

const RadioComponent: FcWithFlag<RadioProps, 'isRadio'> = ({
    checked,
    disabled,
    invalid,
    onChange,
    readOnly,
    'aria-label': ariaLabel,
    'data-qa': dataQaInput,
    dataQaContainer = 'radio-container',
    dataQaRadio = 'radio',
    ...props
}) => {
    const forceDisabled = useDisabled();

    return (
        <span className={styles.radioContainer} data-qa={dataQaContainer}>
            <input
                {...props}
                checked={checked}
                data-qa={dataQaInput}
                // Checkable Card вызывает event.preventDefault(),
                // из-за чего браузер не перерисовывает радиокнопку при изменении пропа checked,
                // поэтому в controlled радиокнопках полагаемся на CSS-класс, а не на селектор :checked
                className={classnames(styles.radioInput, {
                    [styles.radioInputChecked]: checked,
                    // нужно отличать false от undefined, потому что в случае uncontrolled радиокнопки
                    // checked равен undefined и значение задается через проп defaultChecked
                    [styles.radioInputUnchecked]: Object.is(checked, false),
                })}
                type="radio"
                readOnly={readOnly}
                aria-label={ariaLabel}
                disabled={forceDisabled || !!disabled}
                onChange={onChange}
            />
            <span
                className={classnames(styles.radio, {
                    [styles.invalid]: invalid,
                })}
                data-qa={dataQaRadio}
            />
            <span className={styles.iconWrapper}>
                <RadioCircleSize24 />
            </span>
        </span>
    );
};

RadioComponent.isRadio = true;

export const Radio = enrichWithSkeleton(RadioComponent, RadioSkeleton);
